<template>
  <div class="shadow bg-white px-4 py-3">
    <div slot="header" class="header-user flex justify-between items-center mb-4">
      <span class="title-header">グループ一覧</span>
      <div class="flex justify-end custom-header-search">
        <el-input
          placeholder="検索"
          v-model="keySearch"
          @keyup.native="keyUpSearch()"
          class="mr-6 w-1/2 custom-btn-input"
        >
          <template #append>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="getOrganizations"
              class="cursor-pointer"
            >
              <path
                d="M15.102 14.1188L10.4645 9.48129C11.1841 8.55093 11.5734 7.41343 11.5734 6.21701C11.5734 4.78486 11.0145 3.44201 10.0038 2.42951C8.99306 1.41701 7.64663 0.859863 6.21627 0.859863C4.78592 0.859863 3.43949 1.41879 2.42877 2.42951C1.41627 3.44022 0.859131 4.78486 0.859131 6.21701C0.859131 7.64736 1.41806 8.99379 2.42877 10.0045C3.43949 11.017 4.78413 11.5741 6.21627 11.5741C7.4127 11.5741 8.54842 11.1849 9.47877 10.467L14.1163 15.1027C14.1299 15.1163 14.146 15.1271 14.1638 15.1345C14.1816 15.1418 14.2006 15.1456 14.2198 15.1456C14.2391 15.1456 14.2581 15.1418 14.2759 15.1345C14.2937 15.1271 14.3098 15.1163 14.3234 15.1027L15.102 14.3259C15.1156 14.3123 15.1264 14.2962 15.1338 14.2784C15.1411 14.2606 15.1449 14.2416 15.1449 14.2224C15.1449 14.2031 15.1411 14.1841 15.1338 14.1663C15.1264 14.1485 15.1156 14.1324 15.102 14.1188ZM9.04484 9.04558C8.2877 9.80093 7.28413 10.217 6.21627 10.217C5.14842 10.217 4.14485 9.80093 3.3877 9.04558C2.63235 8.28843 2.21627 7.28486 2.21627 6.21701C2.21627 5.14915 2.63235 4.14379 3.3877 3.38843C4.14485 2.63308 5.14842 2.21701 6.21627 2.21701C7.28413 2.21701 8.28949 2.63129 9.04484 3.38843C9.8002 4.14558 10.2163 5.14915 10.2163 6.21701C10.2163 7.28486 9.8002 8.29022 9.04484 9.04558Z"
                fill="black"
                fill-opacity="0.45"
              />
            </svg>
          </template>
        </el-input>

        <el-button
          @click="isOpenCreateModal = true"
          type="text"
          title="テンプレートを追加する"
          class="custom-btn-add px-4 text-black"
        >
          グループ作成
        </el-button>
      </div>
    </div>
    <ErrorMessage :messages="errorMessages" @close="errorMessages = null" />

    <!-- DATA -->
    <div class="w-full data-user mt-4">
      <el-table :data="organizations">
        <template v-slot:empty>
          <span>データなし</span>
        </template>
        <el-table-column label="グループ名" prop="name" min-width="300"></el-table-column>
        <el-table-column label="アカウントID" prop="contact_email" min-width="300"></el-table-column>
        <el-table-column label="有効期限" min-width="100" >
          <template slot-scope="scope">
            <p>{{ formatDate(scope.row.expired_at) }}</p>
          </template>
        </el-table-column>
        <el-table-column min-width="250" align="right">
          <template slot-scope="scope">
            <el-button
                type="primary"
                size="small"
                @click="edit(scope.row)"
                icon="el-icon-edit"
            >
            </el-button>
            <el-button
                type="info"
                size="small"
                @click="showDetailOrigin(scope.row)"
            >
              <i class="el-icon-user"></i>
            </el-button>
            <el-button
                @click="openDeleteModal(scope.row)"
                type="danger"
                size="small"
                icon="el-icon-delete"
            >
            </el-button>
<!--            <el-button-->
<!--                @click="showDetailStatistical(scope.row)"-->
<!--                type="warning"-->
<!--                size="small"-->
<!--                icon="el-icon-s-data"-->
<!--            >-->
<!--            </el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      class="text-right mt-4"
      :current-page.sync="paginate.currentPage"
      :page-sizes="configPaginate.page_sizes"
      :page-size="configPaginate.page_size"
      layout="prev, pager, next, sizes"
      :total="paginate.totalItem"
      @current-change="getOrganizations"
      @size-change="handleSizeChange"
    />
    <CreateOrganization
      :isOpenCreateModal.sync="isOpenCreateModal"
      @close="isOpenCreateModal = false"
      @onOrganizationCreated="onOrganizationCreated"
    />
    <EditOrganization
      :isOpenEditModal.sync="isOpenEditModal"
      :organizationId="organizationId"
      @close="isOpenEditModal = false"
      @onOrganizationUpdated="onOrganizationUpdated"
    />
    <el-dialog title="" :visible.sync="isOpenDeleteModal" width="30%" :show-close="false" class="ocr-dialog">
      <span>この組織を削除しますか。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isOpenDeleteModal = false" class="ocr-button ocr-button-default">いいえ</el-button>
        <el-button type="danger" class="btn-main ocr-button" @click="submitDelete">
          はい、削除する
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CreateOrganization from "@/components/admin/organizations/create";
import EditOrganization from "@/components/admin/organizations/edit";
import ErrorMessage from "@/components/ErrorMessage";
import { configPaginate } from "@/config/paginate";
import formatDate from "@/plugins/formatDate.js";

export default {
  name: "Organization",
  components: {
    CreateOrganization,
    EditOrganization,
    ErrorMessage,
  },
  data: function() {
    return {
      configPaginate,
      paginate: {
        currentPage: 1,
        totalPage: 1,
        totalItem: 1,
      },
      isOpenCreateModal: false,
      organizationId: null,
      isOpenEditModal: false,
      isOpenDeleteModal: false,
      errorMessages: null,
      keySearch: "",
      typingTimer: null,
    };
  },

  computed: {
    ...mapState({
      organizations: (state) => state.admin_organizations.organizations,
      total: (state) => state.admin_organizations.total,
      limit: (state) => state.admin_organizations.limit,
    }),
  },

  methods: {
    ...mapActions("admin_organizations", ["getList", "deleteOrganization"]),
    formatDate,
    handleSizeChange(val) {
      this.configPaginate.page_size = val;
      this.getOrganizations();
    },
    async getOrganizations() {
      const data = {
        page_size: this.configPaginate.page_size,
        page: this.paginate.currentPage,
        key_search: this.keySearch,
      };
      const rs = await this.getList(data);
      this.paginate.currentPage = rs.data.current_page;
      this.paginate.totalPage = rs.data.num_pages;
      this.paginate.totalItem = rs.data.count;
    },
    showDetailStatistical(org) {
      this.$router.push({ name: 'admin_statistical_organizations', params: {id: org.id}})
    },
    showDetailOrigin(org) {
      this.$router.push({ name: 'admin_user_organizations', params: {id: org.id}})
    },

    onOrganizationCreated() {
      this.paginate.currentPage = 1
      this.getOrganizations();
      this.isOpenCreateModal = false;
    },

    edit(item) {
      this.organizationId = item.id;
      this.isOpenEditModal = true;
    },

    async onOrganizationUpdated() {
      await this.getOrganizations()
      this.isOpenEditModal = false;
    },

    openDeleteModal(item) {
      this.organizationId = item.id;
      this.isOpenDeleteModal = true;
    },

    async submitDelete() {
      let res = await this.deleteOrganization({
        id: this.organizationId,
      });
      this.isOpenDeleteModal = false;
      if (!res.success) {
        this.errorMessages = res.data;
        return false;
      }
      this.errorMessages = null;
      this.paginate.currentPage = 1
      await this.getOrganizations()
    },

    viewStat(item) {
      this.$router.push({
        name: "admin_organization_stat",
        params: { id: item.id },
      });
    },

    keyUpSearch() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        this.getOrganizations();
      }, 500);
    },
  },

  created: function() {
    this.getOrganizations();
  },
};
</script>

<style scoped>
.custom-btn-add {
  background: #fdb92c;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #0f172a;
  padding: 5px 16px;
  font-weight: 400;
}
.data-user table th {
  padding: 17px 10px;
  font-weight: 500;
  background: #fdf4e0;
  text-align: left;
}
.data-user table td {
  padding: 10px;
}

@media screen and (max-width: 768px) {
  .header-user {
    flex-wrap: wrap;
  }
  .title-header {
    width: 100%;
  }
  .custom-header-search {
    width: 100%;
    flex-wrap: wrap;
  }
  .custom-header-search {
    justify-content: flex-start;
  }
  .custom-btn-input {
    margin: 10px 0;
    width: 100%;
  }
}
</style>
